import { render, staticRenderFns } from "./addDutyinfo.vue?vue&type=template&id=29001b25&scoped=true&"
import script from "./addDutyinfo.vue?vue&type=script&lang=js&"
export * from "./addDutyinfo.vue?vue&type=script&lang=js&"
import style0 from "./addDutyinfo.vue?vue&type=style&index=0&id=29001b25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29001b25",
  null
  
)

export default component.exports